/**
 * Error Handling System
 * 
 * This module exports a centralized error handling system for the application.
 * It provides utilities for handling, logging, and reporting errors consistently.
 */

// Re-export everything from the error service
export * from './errorService';

// Re-export error types and categories
export * from './errorTypes';

// Import the default export from errorService
import errorService from './errorService';

// Export the default error service
export default errorService;
